















































import Vue, { PropType } from 'vue';
import { UrlTrainingModuleItemModel, UrlTrainingModuleItemResult } from '../../../_GeneratedClients/SpotClient';
import { Moment } from 'moment';
import { implicitStartTrainingPath } from '@/repository';

export default Vue.extend({

  name: 'DisplayAssignedModuleUrlElement',

  props: {
    /** the module url element to be displayed */
    element: { type: Object as PropType<UrlTrainingModuleItemModel>, required: true },
    /** the actual result of the element */
    result: { type: Object as PropType<UrlTrainingModuleItemResult>, required: true },
    /** true if parent module is disabled */
    disabled: { type: Boolean, default: false },
    /** true if action button click must have a result */
    isActive: { type: Boolean, default: false },
    /** id of the parent path so it can be started on 'open document' event */
    pathId: { type: String, default: '' }
  },

  methods: {
    getDisplayableDate (date: Moment): string {
      return date.format(this.$t('dateFormat.pattern').toString());
    },
    getDisplayableTime (date: Moment): string {
      return date.format(this.$t('dateFormat.timePattern').toString());
    },
    onUrlClicked (): void {
      if (!this.disabled && this.isActive && !this.done) {
        this.$emit('urlClicked');
      }
    },
    onOpenDocument () {
      this.implicitStartPath(this.pathId);
    },
    async implicitStartPath (pathId: string): Promise<void> {
      await implicitStartTrainingPath(pathId);
      this.$emit('updatePathStatus');
    }
  },

  computed: {
    done: function (): boolean {
      return this.result.doneAt !== undefined;
    }
  }
});

